module.exports = __webpack_public_path__ + "assets/chevron-right-small-3de942.svg";